import React, { useState, useEffect, useCallback } from "react";
import DebounceSearchInput from '../../constant/DebounceSearchInput'
import { CancelRequest } from "../../../services/AxiosInstance";
import { useNavigate } from "react-router-dom";
import TableLoaderEffect from "../../constant/TableLoader";
import Pagination from "../../constant/Pagination";
import { getQuizListApi } from "../../../services/QuizService";


const AdminQuizList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [filter, setFilter] = useState({
    query: "",
  });

  const recordsPage = 25;

  const navigate = useNavigate();

  const fetchData = useCallback(() => {
    CancelRequest();
    setIsLoading(true);
    getQuizListApi(currentPage, recordsPage, filter)
      .then((resp) => {
        setData(resp.data.data);
        setTotal(resp.data.total);
      })
      .catch((error) => {
        console.error(error.response?.data?.message || "Error fetching data");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [currentPage, filter]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);


  const handlePagination = (page) => {
    setCurrentPage(page.selected + 1);
  };


  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setFilter((prev) => ({
      ...prev,
      query: value,
    }));
    setCurrentPage(1);
  };
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body p-0">
              <div className="table-header">
                <h3 className="mb-0">Quiz</h3>
                <div className="table-left-header">
                  <div className="form-group me-3">
                    <DebounceSearchInput
                      handleSearchChange={handleSearchChange}
                    />
                  </div>
                  <button className="btn btn-primary" onClick={() => navigate("/add-quiz")}>
                    Add Quiz
                  </button>
                </div>
              </div>

              <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                <table
                  id="employees-tblwrapper"
                  className="table ItemsCheckboxSec dataTable no-footer mb-0"
                >
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Description</th>
                      <th>No. of Questions</th>
                      <th>Date Of Publish</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody >
                    {isLoading ? (
                      <TableLoaderEffect colLength={5} />
                    ) : data && data.length > 0 ? (
                      data.map((item, index) => (
                        <tr key={item.id || index} onClick={() => navigate(`/quiz/${item.id}`)}>
                          <td className="text-wrap text-primary fw-bold c-pointer" style={{ maxWidth: "200px" }}>{item.title}</td>
                          <td className="text-wrap" style={{ maxWidth: "300px" }}>{item.description}</td>
                          <td>
                              {item.question_count }
                          </td>

                          <td>{item.publish_date || "NA"} </td>
                          <td>
                            {item?.is_published ? (
                              <span className="badge light border-0 badge-info badge-sm">
                                Publish
                              </span>
                            ) : (
                              <span className="badge light border-0 badge-danger badge-sm">
                                Unpublish
                              </span>
                            )}


                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {isLoading ? (
                <div style={{ height: "4rem" }}></div>
              ) : (
                <Pagination
                  currentPage={currentPage}
                  recordsPage={recordsPage}
                  dataLength={total}
                  handlePagination={handlePagination}
                />
              )}

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AdminQuizList
